export default __webpack_public_path__ + "static/media/sharing-success.e8dbd44d.jpg";